import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-2 bg-neutral-300 rounded px-2 py-0.5 text-sm" }


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterBadge',
  props: {
    label: {},
    value: {}
  },
  emits: ["remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
function handleRemove() {
  emit('remove');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.label) + ": " + _toDisplayString(_ctx.value), 1),
    _createElementVNode("button", {
      onClick: _withModifiers(handleRemove, ["prevent"])
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "text-base material-symbols-outlined" }, "close", -1)
    ]))
  ]))
}
}

})